import { css } from '@/styled-system/css';

// Main container for the key-value pair using flexbox space-between layout
export const keyValueContainer = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '2x', // Ensure minimum 16px gap between label/value
  minWidth: 0, // Allow content to shrink when necessary
});

// Styling for the key/label (left side)
export const keyValueLabel = css({
  color: 'hpxGrey500', // User requirement - grey color for labels
  fontSize: 'md', // 16px - User requirement
  fontWeight: '400', // Regular weight - User requirement
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  textAlign: 'left', // Ensure left alignment
});

// Styling for the value (right side)
export const keyValueValue = css({
  color: 'hpxBlue500', // User requirement - blue color for values
  fontSize: 'md', // 16px - User requirement
  fontWeight: '700', // Bold weight - User requirement
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  textAlign: 'right', // Ensure right alignment
  wordWrap: 'break-word', // Handle long values gracefully
  overflowWrap: 'break-word', // Modern alternative for better browser support
});
